module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticStyle: {
      "padding": "10px 30px 10px 30px"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('draggable', {
    staticClass: "row align-center justify-center",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.media),
      callback: function($$v) {
        _vm.media = $$v
      },
      expression: "media"
    }
  }, _vm._l((_vm.media), function(img, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "4",
        "md": "2",
        "lg": "2",
        "sm": "3"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [(img.preview.thumbnail) ? _c('v-card', {
            staticClass: "mx-auto",
            attrs: {
              "flat": "",
              "elevation": hover ? 16 : 2
            },
            on: {
              "click": function($event) {
                return _vm.viewMedia(img)
              }
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": img.preview.thumbnail,
              "lazy-src": img.preview.thumbnail,
              "aspect-ratio": "1"
            }
          })], 1) : _c('v-card', {
            staticClass: "mx-auto",
            attrs: {
              "flat": ""
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            staticStyle: {
              "max-height": "226px"
            },
            attrs: {
              "src": img.preview.thumbnail,
              "lazy-src": img.preview.thumbnail,
              "aspect-ratio": "1"
            }
          })], 1)]
        }
      }], null, true)
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "text-align": "center"
      }
    }, [_vm._v("\n            " + _vm._s(img.preview.name) + "." + _vm._s(img.preview.format) + " \n            "), _c('v-btn', {
      attrs: {
        "dark": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteImage(index, img)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "color": "red"
      }
    }, [_vm._v("cancel")])], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "20px"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticStyle: {
      "max-width": "150px"
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 1
    }
  }, [_c('v-card', {
    staticClass: "d-flex",
    staticStyle: {
      "height": "100%",
      "min-width": "100px"
    },
    attrs: {
      "outlined": "",
      "flat": "",
      "tile": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.mediaUpload.click()
      }
    }
  }, [_c('v-btn', {
    staticClass: "ma-auto",
    attrs: {
      "dark": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "images",
      "id": "fileToUpload",
      "accept": _vm.accept,
      "multiple": _vm.multiple || false
    },
    on: {
      "change": _vm.prepareUpload
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    on: {
      "click:outside": _vm.modalClickOutSide
    },
    model: {
      value: (_vm.imageDialog),
      callback: function($$v) {
        _vm.imageDialog = $$v
      },
      expression: "imageDialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.mediaType === 'image') ? _c('v-img', {
    staticClass: "grey lighten-2",
    attrs: {
      "src": _vm.previewMedia
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.mediaType === 'vdo') ? _c('video', {
    staticClass: "custom-preview-img",
    attrs: {
      "id": "postVdo",
      "controls": ""
    }
  }, [_vm._v("             \n            Your browser does not support the video tag.\n        ")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadingDialog),
      callback: function($$v) {
        _vm.loadingDialog = $$v
      },
      expression: "loadingDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-964f257e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/post/UploadMedia.vue
// module id = 2240
// module chunks = 0